import { render, staticRenderFns } from "./DeclareRemind.vue?vue&type=template&id=787656ba"
import script from "./DeclareRemind.vue?vue&type=script&lang=js"
export * from "./DeclareRemind.vue?vue&type=script&lang=js"
import style0 from "./DeclareRemind.vue?vue&type=style&index=0&id=787656ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports